// extracted by mini-css-extract-plugin
export default {"content":"Content_content__0iBJT","main":"Content_main__ndSup"};